import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog as MUIDialog, useMediaQuery, useTheme, } from '@mui/material';
import { DIALOG_TITLE_ID } from './DialogTitle';
export const Dialog = ({ children, open, ...rest }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsx(MUIDialog, { fullWidth: true, maxWidth: "md", fullScreen: isMobile, scroll: "paper", open: open, "aria-labelledby": DIALOG_TITLE_ID, ...rest, children: children }));
};
